// Func = limiting Scope for this file
var lastScrollTop = 0;
(function(){

	/*booking widget*/
	const fullbooking = document.querySelector('.header__booking-holder');
	const bookingWidget = {
		bookingOpen: document.querySelector('.booking-trig-js'),
		bookingClose: document.querySelector('.close-booking-js')
	};

	if(fullbooking) { 
		bookingWidget.bookingOpen.addEventListener('click', function () {
			fullbooking.classList.add('expanded');
		});
		bookingWidget.bookingClose.addEventListener('click', function () {
			fullbooking.classList.remove('expanded');
		});
	}

	/*full navigation*/
    const fullnav = document.querySelector('.header__nav-holder'); 
    const primaryNav = { 
        navOpen: document.querySelector('.nav-btn-js'),
        navClose: document.querySelector('.close-btn-js')
    };

    if(fullnav) {
        primaryNav.navOpen.addEventListener('click', function () {
            fullnav.classList.add('expanded');
        });
        primaryNav.navClose.addEventListener('click', function () {
            fullnav.classList.remove('expanded');
        });
    }

	/*header scroll*/
	let scrollpos = window.scrollY
	const full_header = document.querySelector('.header');
    const red_section = document.querySelector('.red-section');
    const texture_section = document.querySelector('.texture-section');


	/*events page*/

	const monthView = document.getElementById('month-view');
	const listView = document.getElementById('list-view');
	const eventsList = document.getElementById('eventsResults');
	const eventsCalendar = document.getElementById('calendarEvents');

	if(monthView && listView) {
		monthView.addEventListener('click', () => {
			eventsList ? eventsList.classList.add('hidden') : null;
			eventsCalendar ? eventsCalendar.classList.remove('hidden') : null;
		})
		listView.addEventListener('click', () => {
			eventsCalendar ? eventsCalendar.classList.add('hidden') : null;
			eventsList ? eventsList.classList.remove('hidden') : null;
		})
	}

	window.addEventListener('scroll', function() { 
		scrollpos = window.scrollY;

		if (scrollpos >= 80) { 
			full_header.classList.remove("up"),
			full_header.classList.add("down")
		}
		else { 
			full_header.classList.remove("down"),
			full_header.classList.add("up")
		}

        if(red_section){
            if((red_section.offsetTop - 300 <= scrollpos) && (red_section.offsetTop + red_section.clientHeight - 300 >= scrollpos)) {
                red_section.classList.add('show-red')
            } else {
                red_section.classList.remove('show-red')
            }
        }

        if(texture_section){
            if((texture_section.offsetTop - 600 <= scrollpos) && (texture_section.offsetTop + texture_section.clientHeight - 300 >= scrollpos)) {
                texture_section.classList.add('show-texture')
            } else {
                texture_section.classList.remove('show-texture')
            }
        }
        
		/*console.log(scrollpos)*/
	});

	/*button hover states*/
	const all_btns = document.querySelectorAll('.btn');
	for (let i = 0; i < all_btns.length; i++) {
		let extra_btn_copy = all_btns[i].textContent;
		all_btns[i].innerHTML = extra_btn_copy+'<span class="mask-copy">'+extra_btn_copy+'</span>';   
	}

	let $slick_home = $('.slider-home-js');

	$slick_home.on('afterChange', function(event, slick, currentSlide){
		$('.slider-home-js .slick-slide .slider__img-side').removeClass('animate-slide-fade-out');
		$('.slider-home-js .slick-slide .slider__img-side').addClass('animate-slide-fade-in');
	})
	.on('beforeChange', function(event, slick, currentSlide){
		$('.slider-home-js .slick-slide .slider__img-side').removeClass('animate-slide-fade-in');
		$('.slider-home-js .slick-slide .slider__img-side').addClass('animate-slide-fade-out');
	})
	.slick({
		centerMode: true,
		centerPadding: '8%',
		accessibility: true,
		speed: 0,
		infinite: true,
		speed: 0, 
		arrows: true,
		dots: false,
		autoplay: false
	});

	$(document).ready(function () {

		if ($(window).width() > 768) {
			let slider_all = document.querySelectorAll('section.slider');

			slider_all.forEach(slider => {
 
				slider.addEventListener('mousemove', function(event) { 
				let rect = slider.getBoundingClientRect(); 
				let x = event.clientX - rect.left; 
				let y = event.clientY - rect.top; 

					if( x > (slider.clientWidth / 2) ){
						slider.querySelector('.slick-prev').style.transform = 'scale(0)'
						slider.querySelector('.slick-next').style.transform = 'scale(1)';
					}else{
						slider.querySelector('.slick-prev').style.transform = 'scale(1)'
						slider.querySelector('.slick-next').style.transform = 'scale(0)';
					}
				
				}); 

				slider.addEventListener('mouseout', function(event) { 
						slider.querySelector('.slick-prev').style.transform = 'scale(0)'
						slider.querySelector('.slick-next').style.transform = 'scale(0)';
				}); 
			});

        }

		/*Properties Day's Calendar [Enable/Disable,ClassName,Tooltip]*/
		let DATE_STYLE = [true];
		function calendarRange(date){			
			let d1=$.datepicker.parseDate(DATE_FORMAT,$('#CheckIn').val());		
			let d2=$.datepicker.parseDate(DATE_FORMAT,$('#CheckOut').val());
			if (d1 && date.getTime() == d1.getTime() || d2 && date.getTime() == d2.getTime()) {
				DATE_STYLE[1] = 'highlight-top';
			}else if(date > d1 && date < d2){
				DATE_STYLE[1] = 'highlight';
			}else{
				DATE_STYLE[1] = '';
			}
			return DATE_STYLE;
		}

		/* Open active sub-nav on load
		$('.privary-navigation ul.submenu li .active').closest('.inner').addClass('open')
		$('.privary-navigation ul.submenu li .active').parents().parents('li').addClass('item-open');
		$('.privary-navigation ul.submenu li .active').closest('.submenu').slideDown(300, function() {}).addClass('menu-open');*/

		/* Main Nav Dropdown*/
		$("#primary-nav li").hover(function(){
			$(this).addClass("hover");
			$('ul.submenu',this).fadeIn(200);
		}, function(){
			$(this).removeClass("hover");
			$('ul.submenu',this).fadeOut(200);
		});

		/*Toggle open/close on tap*/
		$('.primary-navigation li a').off('click').on('click', function(event) {
			if ( $(this).parent().children(".submenu").length > 0 ) {

				event.preventDefault();

				$('.submenu li a').removeClass('active');
				$(this).addClass('active');

				if ($(this).next().next().hasClass('menu-open')) {
					$(this).closest('.submenu li a').removeClass('open');
					$('.primary-navigation ul li').removeClass('item-open');
					$(this).parent().addClass('item-open');
					$(this).next().next().slideUp(300, function(){
						if($('.primary-navigation ul li a').hasClass('active')){
							$(".item-open").get(0).scrollIntoView(false);
						} 
					}).removeClass('menu-open');	                
				} else {
					$(this).closest('.inner').addClass('open');
					$('.primary-navigation ul li').removeClass('item-open');
					$(this).parent().addClass('item-open');
					$('.submenu.menu-open').slideUp(300).removeClass('menu-open'); 
					$(this).next().next().addClass('menu-open').slideDown(300, function(){
						if($('.primary-navigation ul li a').hasClass('active')){
							$(".item-open").get(0).scrollIntoView(false);
						} 
					});
				}
			}
		});


		/*Check in and check out datepicker for booking engine*/
		const DATE_FORMAT = ($("#CheckIn").data("format") !== undefined && $("#CheckIn").data("format")) ? $("#CheckIn").data("format") : "yy-mm-dd";
		function setTabindex() {
			document.querySelectorAll('#booking-form .checkin input, #booking-form .checkout input, #booking-form .adults select, #booking-form .children select, #booking-form .submit button').forEach((e, index) => {
				e.setAttribute('tabindex', index + 1);
			});
		}

        $( "#CheckIn" ).datepicker({
			/*showOn: "both",
			buttonImage: SITE_FILES+"images/img-calendar-gray.png",
			buttonImageOnly: true,*/
			changeMonth: true,
            dateFormat: DATE_FORMAT,
            numberOfMonths: 1,
			minDate: 0,
			beforeShowDay: (date) => calendarRange(date),
			onSelect: function( selectedDate ) {
				let getDate = $(this).datepicker('getDate');
				let newDate = new Date(getDate.getTime());
				newDate.setDate(newDate.getDate() + 3);
				$( "#CheckOut" ).datepicker( "setDate", newDate );
				$( "#CheckOut" ).datepicker( "option", "minDate", selectedDate );
			},
		});
		$( "#CheckOut" ).datepicker({
			/*showOn: "both",
			buttonImage: SITE_FILES+"images/img-calendar-gray.png",
			buttonImageOnly: true,*/
            dateFormat: DATE_FORMAT,
            changeMonth: true,
			numberOfMonths: 1,
			beforeShowDay: (date) => calendarRange(date),
			onSelect: function( selectedDate ) {
				/*$( "#CheckIn" ).datepicker( "option", "maxDate", selectedDate );*/
			}
		});
		setTimeout(function(){
			$('#attraction-category option[value="Art"]').html('Art &amp; Music');
			$('#attraction-category option[value="Under the Water"]').html('Water Activities');
			$('#attraction-category option[value="On Campus"]').html('Onsite Rentals');
		}, 1000);
		
		
	});

}()); 
